import { IAbstractModel } from './abstract.model';

export enum TipoPessoa {
    FISICA = 'F',
    JURIDICA = 'J',
    ESTRANGEIRA = 'E',
}

export interface IConsumidor extends IAbstractModel {
    identificacao?: string;
    nome?: string;
    email?: string;
    tipoPessoa?: TipoPessoa;
    guias?: string[];
    representantes?: string[];
    website?: string;
    redeSocial?: string;
    nomeFantasia?: string;
    consumidorFinal?: boolean;
}
